import MaxLogo from '@assets/max-logo.jpg';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import * as React from 'react';

export type TransparentLoaderProps = {
  isLoading?: boolean;
  message?: string;
};

const TransparentLoader = ({ isLoading, message }: TransparentLoaderProps) => {
  return (
    <Backdrop
      sx={(theme) => ({
        color: theme.palette.common.white,
        zIndex: theme.zIndex.modal + 1,
      })}
      open={isLoading === true}
    >
      <Paper style={{ opacity: 0.85 }}>
        <Box
          margin={4}
          minWidth='20rem'
          display='flex'
          flexDirection='column'
          alignItems='center'
          gap={4}
        >
          <Box
            component='img'
            src={MaxLogo}
            alt='Max Logo'
            sx={{ width: '200px', height: 'auto' }}
          />
          <Box display='flex' gap={2} alignItems='center'>
            <Typography variant='h6'>{message}</Typography>
            <CircularProgress size={24} />
          </Box>
        </Box>
      </Paper>
    </Backdrop>
  );
};

export default TransparentLoader;
